import { useState, useEffect } from "react";
import type { Group } from "@domaddress/shared";
import { api } from "../lib/api";

interface Props {
  group: Group | null;
  onClose: () => void;
  onSaved: () => void;
}

export default function GroupFormModal({ group, onClose, onSaved }: Props) {
  const isEdit = !!group;
  const [form, setForm] = useState({
    name: group?.name ?? "",
    description: group?.description ?? "",
    email: group?.email ?? "",
  });

  // Als je een andere groep opent in hetzelfde modaal, toon de juiste velden
  useEffect(() => {
    setForm({
      name: group?.name ?? "",
      description: group?.description ?? "",
      email: group?.email ?? "",
    });
  }, [group]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSaving(true);
    setError("");
    try {
      const body = {
        name: form.name,
        description: form.description,
        // Leeg = geen e-mail; bij bewerken expliciet meesturen (server wist dan het veld)
        email: form.email.trim() === "" ? (isEdit ? null : undefined) : form.email.trim(),
      };
      if (isEdit) {
        await api.put(`/api/groups/${group.id}`, body);
      } else {
        await api.post("/api/groups", body);
      }
      onSaved();
    } catch (err: any) {
      setError(err.response?.data?.error ?? "Er ging iets mis");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-sm" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{isEdit ? "Groep bewerken" : "Nieuwe groep"}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit} className="modal-body">
          <div className="form-group">
            <label>Naam *</label>
            <input
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Bijv. Kerkraad"
            />
          </div>
          <div className="form-group">
            <label>Omschrijving</label>
            <textarea
              rows={3}
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              placeholder="Optionele toelichting…"
            />
          </div>
          <div className="form-group">
            <label>E-mail groep (optioneel)</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="Bijv. kerkraad@…"
            />
            <p className="data-list-row-muted" style={{ fontSize: "0.8rem", margin: "0.25rem 0 0" }}>
              Gezamenlijk adres van de groep, apart van persoonlijke adressen.
            </p>
          </div>
          {error && <p className="form-error">{error}</p>}
          <div className="modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Annuleren</button>
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? "Opslaan…" : isEdit ? "Wijzigingen opslaan" : "Groep aanmaken"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
